export default {
  // finance-transfer-meta.tsx
  Tranfers: "Transferts",
  "Transfer fund": "Transférer des fonds",
  Amount: "Montant",
  "From Account": "Compte source",
  "To Account": "Compte destination",
  "Created At": "Créé le",
  Actions: "Actions",

  // finance-transfer-form.tsx
  "Select source account": "Sélectionner le compte source",
  "Select destination account": "Sélectionner le compte destination",

  // select-finance-transfer.tsx
  "Finance Transfer": "Transfert financier",
  "Search by amount or accounts": "Rechercher par montant ou comptes",
  "Edit Selection": "Modifier la sélection",
  "No transfers found": "Aucun transfert trouvé",
  "Transferred on": "Transféré le",

  // create-finance-transfer-modal.tsx
  "Create a new transfer": "Créer un nouveau transfert",

  // edit-finance-transfer-modal.tsx
  "Edit Transfer": "Modifier le transfert",

  // view-finance-transfer-modal.tsx
  "Transfer Details": "Détails du transfert",
  "Updated At": "Mis à jour le",

  // delete-finance-transfer-modal.tsx
  "Do you really want to delete this transfer?":
    "Voulez-vous vraiment supprimer ce transfert ?",
  "Warning: This action is irreversible.":
    "Attention : cette action est irréversible.",
  "Confirm Deletion": "Confirmer la suppression",
  Cancel: "Annuler",

  // finance-transfer-list-block.tsx
  "Finance Transfers": "Transferts financiers",
  "Add transfer": "Ajouter un transfert",

  Submit: "Soumettre",
};
